module.exports = __webpack_public_path__ + "img/doc-interactive-service.29307d5f.png";